import { type ReactElement, type ReactNode } from 'react'
import { getSize } from 'app/components/AvatarBlurhash'
import { cn } from '@util'
import { Text } from '@mantine/core'
import { getBorderColor, getTextColor, isEmoji, isMaterialSymbol, Typography } from '@front/model'
import { type IconDisplaySize, type CommonIconDisplayProps } from './types'
import { MaterialSymbolIcon, type MaterialSymbolIconProps } from './MaterialSymbolIcon'

type Props = {
  icon?: string
  color?: string
} & CommonIconDisplayProps
export const IconEmojiDisplay = ({ icon, color, size }: Props): ReactNode => {
  const iconSize = getSize(size)
  return (
    <div
      className={cn(
        'grid place-content-center rounded-full bg-[var(--mantine-color-gray-filled)] aspect-square flex-none'
      )}
      style={{
        backgroundColor: color,
        width: iconSize,
        height: iconSize,
        borderWidth: '2px',
        borderColor: getBorderColor(color),
        borderStyle: 'solid',
      }}
    >
      {icon &&
        (isEmoji(icon) ? (
          <Emoji emoji={icon} size={size} />
        ) : (
          <Icon icon={icon} size={size} iconColor={color ? getTextColor(color) : 'white'} />
        ))}
    </div>
  )
}

type EmojiProps = {
  emoji: string
} & CommonIconDisplayProps

const Emoji = ({ emoji, size = 'md' }: EmojiProps): ReactElement => {
  return <span style={{ fontSize: Typography.size[size], textAlign: 'center' }}>{emoji}</span>
}

type IconProps = {
  icon: string
  iconColor: string
} & CommonIconDisplayProps
const Icon = ({ icon, iconColor, size = 'md' }: IconProps): ReactNode => {
  if (!isMaterialSymbol(icon)) return <Text style={{ color: iconColor }}>{icon}</Text>
  return <MaterialSymbolIcon color={iconColor} icon={icon} size={resolveIconSize(size)} />
}

const resolveIconSize = (size: IconDisplaySize): MaterialSymbolIconProps['size'] => {
  switch (size) {
    case 'xs':
      return 'md'
    case 'sm':
      return 'lg'
    case 'md':
      return 'xl'
  }
}
